import { axiosInstance } from "../../utils/axios";
import { DocumentPart } from "../models";
import { EmbeddedRoots } from "../models/embedded-roots";
import { normalizePath } from "../../redux/feature/document/document-slice";

export async function fetchDocumentList(path: string): Promise<DocumentPart[]> {
  let pathEncoded = buildPathGetParam(path);
  const resp = await axiosInstance.get(`/documentpart/documentlist${pathEncoded}`);
  return resp.data;
}

export async function fetchDocumentRoots(name: string, page: string): Promise<EmbeddedRoots> {
  if (!name) {
    name = "";
  }
  const ITEMS_PER_PAGE = 20;
  const resp = await axiosInstance.get(`/documentpart/documentroots?name=${name}&page=${page}&size=${ITEMS_PER_PAGE}`);
  return resp.data;
}

export async function fetchExploredDocumentPartLocation(path: string): Promise<DocumentPart[]> {
  let pathEncoded = buildPathGetParam(path);
  const resp = await axiosInstance.get(`/folders${pathEncoded}`);
  return resp.data;
}

export async function fetchZipFileList(path: string): Promise<DocumentPart[]> {
  let pathEncoded = buildPathGetParam(path);
  const resp = await axiosInstance.get(`/documentpart/zipandfolderlist${pathEncoded}`);
  return resp.data;
}

function buildPathGetParam(path: string) {
  if (!path?.length) {
    return "";
  }
  return "?path=" + encodeURIComponent(normalizePath(path));
}

export async function fetchNonTagetikDocumentsList(path: string): Promise<DocumentPart[]> {
  let pathEncoded = buildPathGetParam(path);
  const resp = await axiosInstance.get(`/documentpart/nontagetikdocumentlist${pathEncoded}`);
  return resp.data;
}
